/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import CommonAlertCard from "../../../../../components/_utils/CommonAlertCard/index.jsx";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../../../components/_utils/PaginationComponent";
import BeneficiaryAccountDetailsPopup from "../../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import Loader from "../../../../../components/Loader/Index";
import BeneficiaryTransactionDetailsPopup from "../../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionDetailsPopup/index.jsx";
import BeneficiaryTransactionMultiApprovalCard from "../../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionMultiApprovalCard/index.jsx";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { getAllCategories } from "../../../../../redux/features/sharedResources/sharedResources";
import { beneficiaryTransactionsActionable } from "../../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../../utils/bankingHours.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../../utils/configurationProvider";
import useMultiSelect from "../../../../../utils/useMultiSelect";

const BeneficiaryTransactionMultiSelect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const { handleChange, handleSelectAll: handleMultiSelectAll } =
    useMultiSelect();
  const [page, setPage] = useState(1);
  const [, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [txnId, setTxnId] = useState(null);
  const [mainData, setMainData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [dropdownOptions] = useState(PaginationConfiguration.paginationOptions);
  const [inputData, setInputData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [allAccounts, setAllAccounts] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [selectedValue, setSelectedValue] = useState(50);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [displayCategory, setDisplayCategory] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [beneAccountStatus, setBeneAccountStatus] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [allBeneTxnLoading, setallBeneTxnLoading] = useState(false);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const allCategories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const { beneficiaryTransactionsActionableData } = useSelector(
    (state) => state.beneficiaryTransactions,
  );

  const shouldShowPagination =
    !allBeneTxnLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const isFilterApplied = currentCategory !== "" || LabelSearchText?.length;

  const hasNoData =
    !allAccounts || allAccounts.length === GlobalConfiguration?.lengthCheckZero;
  const shouldShowEmptyState = !allBeneTxnLoading && hasNoData;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const isTransactionPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) => transaction?.lifecycle_status === "pending",
    ) && isOutsideBankingHoursNow;

  const isAccountApprovalPendingOutsideBankingHours =
    allAccounts?.some(
      (transaction) =>
        transaction?.beneficiary_account_approval_status === "pending",
    ) && isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    isTransactionPendingOutsideBankingHours ||
    isAccountApprovalPendingOutsideBankingHours;

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const refreshBeneList = async () => {
    setallBeneTxnLoading(true);
    setPage(1);
    setAllAccounts([]);

    await dispatch(
      beneficiaryTransactionsActionable({
        page_no: GlobalConfiguration?.lengthCheckOne,
        page_size: pageSize,
        category: currentCategory || undefined,
        labels: LabelSearchText,
      }),
    ).unwrap();

    setallBeneTxnLoading(false);
  };

  const handleClearParams = () => {
    setLabelSearchText([]);
    setCurrentCategory("");
    setallBeneTxnLoading(true);
    setPage(1);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    handleChange(
      selectedSendTransactions,
      setSelectedSendTransactions,
      PaginationConfiguration.paginationSmall,
      selectedSendTransactions,
    );
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (page) => {
    setPage(page);
  };

  const approvedData = allAccounts
    .filter(
      (account) => account.beneficiary_account_approval_status === "approved",
    )
    .map((account) => ({ ...account, id: account?.txn_id }));

  const handleSelectAll = () => {
    handleMultiSelectAll(
      selectedSendTransactions,
      setSelectedSendTransactions,
      PaginationConfiguration.paginationSmall,
      approvedData,
    );
  };

  const onMount = async ({
    pageNo = page,
    size = pageSize,
    categoryVal = currentCategory,
    labelsVal = LabelSearchText,
  } = {}) => {
    try {
      setallBeneTxnLoading(true);

      const res = await dispatch(
        beneficiaryTransactionsActionable({
          page_no: pageNo,
          page_size: size,
          category_id: categoryVal || undefined,
          labels: labelsVal?.length ? labelsVal : undefined,
        }),
      );

      const newData =
        res?.payload?.transactions?.map((txn) => ({
          ...txn,
          loading: false,
          error: "false",
          message: "",
        })) || [];

      setAllAccounts(newData);
      setMainData(res?.payload);
    } catch (error) {
      console.error("Failed to fetch beneficiary transactions", error);
    } finally {
      setallBeneTxnLoading(false);
    }
  };

  const fetchFilterData = async () => {
    let response;
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Category":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) || [];
        setInputData(data);
        setLoadingData(false);
        break;

      case "Labels":
        const available =
          beneficiaryTransactionsActionableData?.summary?.available_labels ||
          [];

        const filtered = available.filter((l) =>
          l.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
        );

        data =
          filtered
            ?.filter((itm) => itm.includes(searchUserTextDebounce))
            ?.map((val) => ({ id: val, Label: val })) || [];
        setInputData(data);
        setLoadingData(false);
        break;

      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [dispatch, currentCategory, LabelSearchText, page, pageSize, markerData]);

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const selectedIds =
      selectedSendTransactions?.map((item) => item?.txn_id) || [];
    setSelectedTransactions(selectedIds);
    const total = selectedSendTransactions?.reduce(
      (sum, transaction) =>
        sum +
        Number(transaction?.amount || GlobalConfiguration.lengthCheckZero),
      GlobalConfiguration?.lengthCheckZero,
    );
    setTotalAmount(total);
  }, [selectedSendTransactions, setSelectedTransactions, setTotalAmount]);

  return (
    <>
      {showTxnDetailPop ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneficiaryTransactionDetailsPopup
            closeBeneTxnDetailModal={closeBeneTxnDetailModal}
            bene_txn_id={txnId}
            type="bene_txn_detail_modal"
            onReloadList={refreshBeneList}
          />
        </div>
      ) : null}

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {isDrawerOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={BeneTxnDetailsId}
            beneAccountStatus={beneAccountStatus}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}
      <div className="bg-primary-bg flex flex-col h-screen relative overflow-hidden">
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative flex flex-col overflow-hidden ">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <div className="z-z-index-overlay">
              <TopNavComponent
                ispagination={shouldShowPagination}
                topNavHeader={totalAmount}
                topNavSubText="Total amount"
                prevBalance={0}
                ownerAccBalanceLoading={false}
                BalanceStateRequired={true}
                AllPageRefresh={false}
                isSelectionView={true}
                selectionText={`Transactions selected : ${selectedTransactions.length}`}
                selectionBtnProps={
                  !shouldShowPagination
                    ? undefined
                    : {
                        btnText: `Select up to 50`,
                        btnType: "button",
                        enabledBgColor:
                          selectedTransactions?.length ===
                          PaginationConfiguration.paginationSmall
                            ? "var(--positive-bg)"
                            : "var(--primary-nav-act)",
                        hoverOption:
                          selectedTransactions?.length ===
                          PaginationConfiguration.paginationSmall
                            ? "black"
                            : "white",
                        enabledTextColor: "var(--text-primary)",
                        icon:
                          selectedTransactions?.length ===
                          PaginationConfiguration.paginationSmall
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                        handleFunction: () => {
                          handleSelectAll();
                        },
                      }
                }
                topNavCtaBtn2Props={{
                  inActiveVariantNeeded: true,
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                  handleFunction: () => {
                    if (
                      selectedTransactions?.length >=
                      GlobalConfiguration?.lengthCheckOne
                    ) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval",
                      );
                    }
                  },
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval",
                    ),
                }}
                filteredSearchProps={{
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  showSearchBar: true,
                  isSearchDisabled: loadingData,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search beneficiary transaction",
                  filterPlaceholder: "Search beneficiary transaction",
                  filterItems: [
                    {
                      name: "Category",
                      short_name: "Cat",
                      isMulti: false,
                      value: currentCategory,
                      displayValue: displayCategory,
                      setValue: (val) => {
                        const c =
                          allCategories.filter((x) => x.id === val)[0]?.name ??
                          "";
                        setDisplayCategory(c);
                        setPage(1);
                        setCurrentCategory(val);
                      },
                      isDropdown: true,
                    },
                    {
                      name: "Labels",
                      short_name: "Lab",
                      isMulti: true,
                      value: LabelSearchText,
                      setValue: (val) => {
                        setPage(1);
                        setLabelSearchText(val);
                      },
                      isDropdown: true,
                    },
                  ],
                  isSearchClearAllDisabled: !(
                    currentCategory !== "" ||
                    displayCategory?.length ||
                    LabelSearchText?.length
                  ),

                  inputData: inputData,
                  active: active,
                  setActive: setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: false,
                  isShowSortBy: false,
                }}
              />
            </div>

            <div
              className={`h-height-full flex flex-col overflow-hidden  bg-primary-bg ${
                allAccounts?.length === GlobalConfiguration.lengthCheckZero ||
                allBeneTxnLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              } `}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              <div
                ref={filterRef}
                className="w-width-full overflow-auto h-[-webkit-fill-available] scroll-py-top_md"
              >
                {allBeneTxnLoading ? (
                  <div className="loader-container m-auto justify-center items-center flex h-height-full">
                    <Loader />
                  </div>
                ) : shouldShowEmptyState ? (
                  <div className="int-txn-mutli-no-account-found">
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          (currentCategory !== "" || LabelSearchText?.length) &&
                          !allAccounts?.length
                            ? ICONS?.NO_DATA_FOUND
                            : ICONS?.NO_PENDING_TRANSACTION
                        }
                        alt={
                          !allAccounts?.length
                            ? "FiterNoAccount"
                            : "NoAccountFound"
                        }
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account">
                      {hasNoData && isFilterApplied && (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}

                      {hasNoData && !isFilterApplied && (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Beneficiary transaction dashboard"
                              handleFunction={() =>
                                navigate("/beneficiary_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    {allAccounts?.length ? (
                      <>
                        <div
                          className="flex flex-col flex-1 items-center justify-center mx-auto"
                          style={{
                            scrollPaddingTop: "var(--padding-md)",
                            scrollPaddingBottom: "var(--padding-md)",
                          }}
                        >
                          {shouldShowBankingHoursAlert && (
                            <div className="max-w-tab-width-normal w-full Qlg:mx-auto pt-padding-md px-padding-md Qlg:px-padding-base">
                              <CommonAlertCard
                                title="Functioning outside banking hours"
                                texts="Transactions will be processed automatically during the next bank working day. Learn more"
                                highlightedText={["Learn more"]}
                                onHighlightedTextClick={(event, index) => {
                                  if (index === 0) {
                                    setShowBankingHoursPopup(true);
                                  }
                                }}
                              />
                            </div>
                          )}
                          <BeneficiaryTransactionMultiApprovalCard
                            filterRef={filterRef}
                            data={allAccounts}
                            selectedTransactions={selectedTransactions}
                            selectedSendTransactions={selectedSendTransactions}
                            setSelectedSendTransactions={
                              setSelectedSendTransactions
                            }
                            SetBeneTxnDetailsId={SetBeneTxnDetailsId}
                            setBeneAccountStatus={setBeneAccountStatus}
                            setTxnId={setTxnId}
                            openBeneTxnDetailModal={openBeneTxnDetailModal}
                            isDrawerOpen={isDrawerOpen}
                            setisDrawerOpen={setisDrawerOpen}
                          />
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </div>
            <div
              className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none" : "opacity-base-opacity"}`}
            >
              {shouldShowPagination && (
                <div className="z-z-index-fixed-ui w-screen">
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={page}
                    setIsOpen={setIsOpen}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BeneficiaryTransactionMultiSelect;
